/**
 * Development-only logger.
 *
 * Why a dedicated helper instead of inline `if (process.env.NODE_ENV…)` blocks?
 *   • Single point of truth — flip one constant to silence all dev logs.
 *   • Same call shape as `console.*` so adding a debug line is friction-free.
 *   • At build time, when NODE_ENV === 'production', the function body is a no-op,
 *     so the bundler can dead-code-eliminate the call site arguments too.
 *
 * Note: `console.warn` and `console.error` are NOT routed through this — those
 * are legitimate production signals that should always reach the browser console
 * and any external error reporters (Sentry, OneSignal, etc.).
 */
const isDev = process.env.NODE_ENV !== 'production';

export const devLog = (...args) => {
  if (isDev) console.log(...args);  // eslint-disable-line no-console
};

export const devInfo = (...args) => {
  if (isDev) console.info(...args);  // eslint-disable-line no-console
};

export const devDebug = (...args) => {
  if (isDev) console.debug(...args);  // eslint-disable-line no-console
};
